import { decimalSeparator as decFunc } from './decimalSeparator';

const decimalSeparator = decFunc();

export const formatter = (value) => {
  if (!value && value !== 0) return '';
  const parts = String(value).split('.');
  const intPart = parts[0];
  const decPart = parts[1];
  return (
    intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
    `${decPart ? decimalSeparator + decPart : ''}`
  );
};

export const parser = (value) => {
  if (!value) return '';
  return value
    .replace(/\s/g, '')
    .replace(',', '.');
};

export const parserINT = (value) => {
  return value
    ?.replace(/\s/g, '')
    .replace(',', '')
    .replace('.', '');
};

